<div class="inputHeader-induxtry">
    <span class="firstLabel" [ngStyle]="datapicker?.styleLabel">
        {{ datapicker.label }} <span *ngIf="datapicker.subLabel" class="optionalLabel" [ngStyle]="datapicker?.styleSubLabel">{{datapicker.subLabel}}</span>
        <div
          class="icon_tooltip"
          [matTooltip]="datapicker?.iconTooltip?.text"
          [matTooltipPosition]="datapicker?.iconTooltip?.position ? datapicker?.iconTooltip?.position : 'above'"
          matTooltipClass="induxtry-tooltip"
        >
            <mat-icon [svgIcon]="datapicker?.iconTooltip?.icon"></mat-icon>
        </div>
    </span>
</div>
<mat-form-field [floatLabel]="'always'" appearance="outline"
class="custom-outline-datapicker-input"

>
    <input matInput [placeholder]="datapicker.placeholder" [matDatepicker]="picker" [disabled]="datapicker.disabled"
        [(ngModel)]="datapicker.date" (dateChange)="setNewDate()"
        >
    <mat-datepicker-toggle matSuffix [for]="picker">
        <mat-icon class="calendar-icon" matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
